export const useDecimalInput = (decimalPlaces: number) => {
  const validateDecimal = (event: KeyboardEvent) => {
    const newValue = getNewValue(event);
    if (isAllowedKey(event)) return;

    if (!isNumberOrSingleDecimal(newValue)) {
      event.preventDefault();
      return;
    }

    if (hasExceededAllowedDecimal(newValue)) {
      event.preventDefault();
    }
  };

  const getNewValue = (event: KeyboardEvent) => {
    const input = event.target as HTMLInputElement;
    const start = input.selectionStart || 0;
    const end = input.selectionEnd || 0;

    return input.value.slice(0, start) + event.key + input.value.slice(end);
  };

  const isNumberOrSingleDecimal = (val: string) => /^\d*\.?\d*$/.test(val);

  const isAllowedKey = (event: KeyboardEvent) => {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
    return allowedKeys.includes(event.key);
  };

  const hasExceededAllowedDecimal = (val: string) => {
    const decimalPart = val.split('.')[1];
    return decimalPart && decimalPart.length > decimalPlaces;
  };
  return { validateDecimal };
};
